module.exports = __webpack_public_path__ + "static/chicken_wire-b4447b0ad1ab3c62b96ca63d01b134a1.png";